/**
 * Reports an error if MeadCommon is missing.
 */
export default {
    created: function () {
        if (window.MeadCommon === undefined || window.MeadCommon === null) {
            console.error(`Mead has not been installed, please run Mead.install(Vue). ${this.$options.name}`);
        }
    }
}